/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { MainPageEvent, useMainPageDataSelector } from "../MainUi";

interface ModalProps {
  notification: string;
}

function Notification({ notification }: ModalProps) {
  const dispatch = useDispatch();
  const pageData = useMainPageDataSelector();
  useEffect(() => {
    if (pageData.showNotification) {
      setTimeout(() => {
        dispatch({
          type: MainPageEvent.HIDE_NOTIFICATION,
        });
      }, 3000);
    }
  }, [dispatch, pageData.showNotification]);
  return (
    <div className="notification-box notify-success">
      <div className="container-fluid no-padding">
        <div className="row">
          <div className="col-1 notification-box__icon-area">
            <span className="notification-box__icon">
              <i className="fas fa-check-circle"></i>
            </span>
          </div>
          <div className="col-10">
            <span className="notification-box__text">{notification}</span>
          </div>
          <div className="col-1">
            <span className="notification-box__close">
              <a
                onClick={() => {
                  dispatch({
                    type: MainPageEvent.HIDE_NOTIFICATION,
                  });
                }}
              >
                <i className="fas fa-times-circle"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notification;
